import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { HeaderComponent } from './components/header/header.component';
import { BoardRetrievingService } from './services/board-retrieving.service';
import { BoardStateService } from './services/board-state.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  constructor(
    public readonly boardRetrievingService: BoardRetrievingService,
    public readonly boardStateService: BoardStateService
  ) { }
}
